import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import {
  DropDownListModule,
  DropDownsModule,
} from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { FormFieldModule, InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { MenuModule } from '@progress/kendo-angular-menu';
import { TypographyModule } from '@progress/kendo-angular-typography';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { SharedModule as AppSharedModule } from '../../shared.module';
import { DocumentsModule } from '../documents/documents.module';
import { DocumentUploadComponent } from './document-upload.component';
import { UploadDocumentTypesPipe } from './upload-document-types.pipe';

@NgModule({
  declarations: [DocumentUploadComponent, UploadDocumentTypesPipe],
  imports: [
    CommonModule,
    FontAwesomeModule,
    IconsModule,
    FormFieldModule,
    LabelModule,
    InputsModule,
    ReactiveFormsModule,
    ButtonsModule,
    DropDownListModule,
    TypographyModule,
    MenuModule,
    DialogModule,
    UploadsModule,
    DocumentsModule,
    DateInputsModule,
    LoaderModule,
    GridModule,
    DropDownsModule,
    AppSharedModule,
  ],
  exports: [DocumentUploadComponent],
})
export class DocumentUploadModule {}
